import React from "react";

// IQCards.jsx
const Solutions = [
  {
    key: "image",
    title: "ImageIQ",
    desc: "Turn article images to actionable touchpoints",
    iconWrap: "bg-amber-100",
    iconColor: "text-amber-600",
    Icon: (props) => (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        {...props}
      >
        <rect x="4" y="5" width="16" height="14" rx="2" />
        <path d="M9 10.5h.01M12 12l3 4H9l3-4z" />
      </svg>
    ),
  },
  {
    key: "video",
    title: "VideoIQ",
    desc: "Interactive video widget for measurable views",
    iconWrap: "bg-emerald-100",
    iconColor: "text-emerald-600",
    Icon: (props) => (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        {...props}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.5 10.5l4-2v7l-4-2M5 8h7a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4a2-2 0 012-2z"
        />
      </svg>
    ),
  },
  {
    key: "story",
    title: "StoryIQ",
    desc: "Carousel turning text into compact article snippets",
    iconWrap: "bg-sky-100",
    iconColor: "text-sky-600",
    Icon: (props) => (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        {...props}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13 3L4 14h6l-1 7 9-11h-6l1-7z"
        />
      </svg>
    ),
  },
  {
    key: "pulse",
    title: "PulseIQ",
    desc: "Turn lost archive into fresh engagement, contextually",
    iconWrap: "bg-emerald-100",
    iconColor: "text-emerald-600",
    Icon: (props) => (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        {...props}
      >
        <path d="M1.5 12S5 5.5 12 5.5 22.5 12 22.5 12 19 18.5 12 18.5 1.5 12 1.5 12Z" />
        <circle cx="12" cy="12" r="3.2" />
      </svg>
    ),
  },
];

export default function LandingPage() {
  return (
    <section className="w-full">
      {/* === HERO === */}
      <div>
        <div className="font-bebas font-normal tracking-widest text-[32px] lg:text-[50px] text-left md:text-center leading-[130%]">
          <span className="text-[darkcyan]">Unlocking</span>{" "}
          <span className="text-[orangered]">Incremental</span>{" "}
          <br className="block lg:hidden" />
          <span className="text-[orangered]">Revenue </span>
          <br className="hidden lg:block" />
          <span className="text-[darkcyan]">Through</span>
          <br className="block lg:hidden" />
          <span className="text-[#06382f]"> Content-Aware</span>
          <br className="block" />
          <span className="text-[#06382f]">Engagement</span>
        </div>

        {/* Trusted & Certified */}
        <div className="mt-8 lg:mt-10">
          <div className="text-left md:text-center font-semibold text-[16px] lg:text-lg font-inter text-[darkgreen] leading-[100%]">
            Trusted &amp; Certified
          </div>

          {/* Logos row */}
          <div className="mt-4 lg:mt-6 flex justify-items-start md:justify-center items-center gap-[30px] sm:gap-[50px] lg:gap-[70px] ">
            <img
              src="./googlepartner.png"
              alt="Google Partner"
              className="h-8 lg:h-11 object-contain"
            />
            <img
              src="./aws.png"
              alt="AWS"
              className="h-8 lg:h-11 object-contain"
            />
            <img
              src="./iab.png"
              alt="IAB"
              className="h-8 lg:h-11 object-contain"
            />
          </div>
        </div>
      </div>

      {/* === SOLUTIONS === */}
      <div className="hidden mt-10 lg:mt-14">
        <div className="text-[32px] lg:text-[40px] font-normal font-bebas tracking-[.2em] text-[#06382f] text-center leading-[100%]">
          Solutions
        </div>

        {/* MOBILE (≤ md) */}
        <div className="mt-6 grid grid-cols-2 gap-3 md:hidden">
          {Solutions.map(({ key, title, desc, Icon, iconWrap, iconColor }) => (
            <div
              key={key}
              className="rounded-2xl bg-white/80 ring-1 ring-black/5 px-3 text-center flex flex-col items-center justify-center gap-2  h-[140px] max-w-[190px] w-full mx-auto"
            >
              <div className={`rounded-full ${iconWrap} p-2`}>
                <Icon className={`w-6 h-6 ${iconColor}`} />
              </div>
              <div className="text-[14px] font-bold font-inter text-[#06382f] leading-[100%]">
                {title}
              </div>
              <div className="text-[12px] leading-[120%] font-normal text-[#004D4D] font-inter">
                {desc}
              </div>
            </div>
          ))}
        </div>

        {/* DESKTOP (≥ md) */}
        <div className="hidden md:grid mt-8 grid-cols-4 md:gap-4 lg:gap-6 max-w-4xl mx-auto">
          {Solutions.map(({ key, title, desc, Icon, iconWrap, iconColor }) => (
            <div
              key={key}
              className="
                bg-white/90 rounded-2xl shadow-md ring-1 ring-black/5
                text-center flex flex-col items-center justify-center gap-[10px] 
                h-[170px] px-3 
                max-w-[220px] w-full mx-auto
              "
            >
              <div className={`rounded-full ${iconWrap} p-2.5`}>
                <Icon className={`md:w-7 md:h-7 lg:w-8 lg:h-8 ${iconColor}`} />
              </div>
              <div className="font-inter text-[#06382f] leading-[100%] md:text-[16px] lg:text-[18px] font-bold">
                {title}
              </div>
              <div className="font-inter text-[#004D4D] font-normal md:text-[13px] lg:text-sm leading-[120%]">
                {desc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
